
const fadeIn = {
    initial: { opacity: 0 },
    final: {
        opacity: 1,
        transition: {
            duration: 1.0,
        },
    }
};
export { fadeIn };